export default[
    {
      "emoji": "😊",
      "name_en": "Happy",
      "name_ko": "행복"
    },
    {
      "emoji": "💳",
      "name_en": "credit card",
      "name_ko": "신용카드"
    },
    {
      "emoji": "🍦",
      "name_en": "Soft Ice Cream",
      "name_ko": "아이스크림"
    },
    {
      "emoji": "😌",
      "name_en": "Relieved",
      "name_ko": "안심"
    },
    {
      "emoji": "👨‍💼",
      "name_en": "Worker",
      "name_ko": "직장인"
    },
    {
      "emoji": "💩",
      "name_en": "pile of poo",
      "name_ko": "응가"
    },
    {
      "emoji": "👨‍🎤",
      "name_en": "singer",
      "name_ko": "가수"
    },
    {
      "emoji": "🍿",
      "name_en": "Popcorn",
      "name_ko": "팝콘"
    },
    {
      "emoji": "⚾",
      "name_en": "baseball",
      "name_ko": "야구"
    },
    {
      "emoji": "💔",
      "name_en": "Broken Heart",
      "name_ko": "깨진 하트"
    },
    {
      "emoji": "🧝",
      "name_en": "Elf, Fairy",
      "name_ko": "엘프, 요정"
    },
    {
      "emoji": "💌",
      "name_en": "love letter",
      "name_ko": "러브레터"
    },
    {
      "emoji": "😆",
      "name_en": "Excited",
      "name_ko": "신나"
    },
    {
      "emoji": "🌊",
      "name_en": "water wave",
      "name_ko": "물결, 파도"
    },
    {
      "emoji": "🍇",
      "name_en": "Grapes",
      "name_ko": "포도"
    },
    {
      "emoji": "🧧",
      "name_en": "New Year's",
      "name_ko": "새해"
    },
    {
      "emoji": "💨",
      "name_en": "Dashing Away",
      "name_ko": "도망"
    },
    {
      "emoji": "🎳",
      "name_en": "bowling",
      "name_ko": "볼링"
    },
    {
      "emoji": "🦹",
      "name_en": "supervillain, villain",
      "name_ko": "악당"
    },
    {
      "emoji": "👑",
      "name_en": "Royal, Queen, King, Princess, Prince",
      "name_ko": "왕, 여왕, 귀족"
    },
    {
      "emoji": "👻",
      "name_en": "Ghost",
      "name_ko": "유령"
    },
    {
      "emoji": "💡",
      "name_en": "light bulb",
      "name_ko": "전구"
    },
    {
      "emoji": "🏊",
      "name_en": "swim, swimming",
      "name_ko": "수영"
    },
    {
      "emoji": "💯",
      "name_en": "hundred points",
      "name_ko": "100점"
    },
    {
      "emoji": "🍬",
      "name_en": "candy",
      "name_ko": "사탕"
    },
    {
      "emoji": "💥",
      "name_en": "Collision, Crash",
      "name_ko": "충돌"
    },
    {
      "emoji": "✏",
      "name_en": "pencil",
      "name_ko": "연필"
    },
    {
      "emoji": "🙏",
      "name_en": "Thanks",
      "name_ko": "감사"
    },
    {
      "emoji": "🍐",
      "name_en": "fruit",
      "name_ko": "과일"
    },
    {
      "emoji": "💣",
      "name_en": "bomb",
      "name_ko": "폭탄"
    },
    {
      "emoji": "🥊",
      "name_en": "Boxing",
      "name_ko": "복싱"
    },
    {
      "emoji": "🌭",
      "name_en": "Hot Dog",
      "name_ko": "핫도그"
    },
    {
      "emoji": "🌲",
      "name_en": "tree",
      "name_ko": "나무"
    },
    {
      "emoji": "⏱",
      "name_en": "Hurry Up",
      "name_ko": "서둘러"
    },
    {
      "emoji": "😅",
      "name_en": "Embarrassed",
      "name_ko": "당황"
    },
    {
      "emoji": "🍔",
      "name_en": "Hamburger",
      "name_ko": "햄버거"
    },
    {
      "emoji": "😒",
      "name_en": "Annoyed",
      "name_ko": "짜증"
    },
    {
      "emoji": "💦",
      "name_en": "sweat droplets",
      "name_ko": "땀"
    },
    {
      "emoji": "🐶",
      "name_en": "dog, puppy, doggy",
      "name_ko": "강아지"
    },
    {
      "emoji": "😡",
      "name_en": "Angry",
      "name_ko": "화남"
    },
    {
      "emoji": "🐅",
      "name_en": "tiger",
      "name_ko": "호랑이"
    },
    {
      "emoji": "🐱",
      "name_en": "cat",
      "name_ko": "고양이"
    },
    {
      "emoji": "🛋",
      "name_en": "Couch, Sofa",
      "name_ko": "소파"
    },
    {
      "emoji": "😞",
      "name_en": "Disappointed",
      "name_ko": "실망"
    },
    {
      "emoji": "⛸",
      "name_en": "Ice skate",
      "name_ko": "아이스 스케이트"
    },
    {
      "emoji": "🎟",
      "name_en": "ticket, tickets",
      "name_ko": "티켓"
    },
    {
      "emoji": "🦊",
      "name_en": "fox",
      "name_ko": "여우"
    },
    {
      "emoji": "😢",
      "name_en": "Sad",
      "name_ko": "슬퍼"
    },
    {
      "emoji": "🍋",
      "name_en": "Lemon",
      "name_ko": "레몬"
    },
    {
      "emoji": "🚉",
      "name_en": "Station",
      "name_ko": "역"
    },
    {
      "emoji": "🙇",
      "name_en": "Sorry",
      "name_ko": "미안"
    },
    {
      "emoji": "🐷",
      "name_en": "pig",
      "name_ko": "돼지"
    },
    {
      "emoji": "🚕",
      "name_en": "taxi",
      "name_ko": "택시"
    },
    {
      "emoji": "🕳",
      "name_en": "hole",
      "name_ko": "구멍"
    },
    {
      "emoji": "🐰",
      "name_en": "rabbit",
      "name_ko": "토끼"
    },
    {
      "emoji": "🕶",
      "name_en": "sunglasses",
      "name_ko": "선글라스"
    },
    {
      "emoji": "🐣",
      "name_en": "chick, baby chick",
      "name_ko": "병아리"
    },
    {
      "emoji": "👽",
      "name_en": "alien",
      "name_ko": "외계인"
    },
    {
      "emoji": "😱",
      "name_en": "Scared",
      "name_ko": "무서워"
    },
    {
      "emoji": "🍕",
      "name_en": "pizza",
      "name_ko": "피자"
    },
    {
      "emoji": "😐",
      "name_en": "Neutral",
      "name_ko": "무덤덤"
    },
    {
      "emoji": "👋",
      "name_en": "Hi",
      "name_ko": "안녕"
    },
    {
      "emoji": "🎆",
      "name_en": "firework",
      "name_ko": "불꽃놀이"
    },
    {
      "emoji": "🚴",
      "name_en": "Bicycle",
      "name_ko": "자전거"
    },
    {
      "emoji": "👎",
      "name_en": "thumbs down",
      "name_ko": "우~"
    },
    {
      "emoji": "🛏",
      "name_en": "Good night",
      "name_ko": "잘자"
    },
    {
      "emoji": "🎤",
      "name_en": "Sing, Microphone",
      "name_ko": "노래, 마이크"
    },
    {
      "emoji": "🍟",
      "name_en": "French Fries",
      "name_ko": "감자튀김"
    },
    {
      "emoji": "🎷",
      "name_en": "musical instrument",
      "name_ko": "악기"
    },
    {
      "emoji": "🌮",
      "name_en": "Taco",
      "name_ko": "타코"
    },
    {
      "emoji": "🧇",
      "name_en": "Dessert",
      "name_ko": "디저트"
    },
    {
      "emoji": "☺",
      "name_en": "Shy",
      "name_ko": "부끄"
    },
    {
      "emoji": "💪",
      "name_en": "Biceps, Muscle",
      "name_ko": "근육"
    },
    {
      "emoji": "🍎",
      "name_en": "apple",
      "name_ko": "사과"
    },
    {
      "emoji": "😲",
      "name_en": "Surprised",
      "name_ko": "놀람"
    },
    {
      "emoji": "🛷",
      "name_en": "Sled",
      "name_ko": "썰매"
    },
    {
      "emoji": "👓",
      "name_en": "glasses",
      "name_ko": "안경"
    },
    {
      "emoji": "🤩",
      "name_en": "Wow",
      "name_ko": "와우"
    },
    {
      "emoji": "🍞",
      "name_en": "bread",
      "name_ko": "빵"
    },
    {
      "emoji": "🦴",
      "name_en": "bone",
      "name_ko": "뼈"
    },
    {
      "emoji": "🍗",
      "name_en": "Poultry Leg",
      "name_ko": "닭다리"
    },
    {
      "emoji": "💆",
      "name_en": "Relaxed",
      "name_ko": "편안"
    },
    {
      "emoji": "🍖",
      "name_en": "Meat",
      "name_ko": "고기"
    },
    {
      "emoji": "🥘",
      "name_en": "meal, food",
      "name_ko": "식사, 음식"
    },
    {
      "emoji": "😘",
      "name_en": "Kiss, Chu",
      "name_ko": "뽀뽀"
    },
    {
      "emoji": "😣",
      "name_en": "Endure, Persevere",
      "name_ko": "참다, 인내"
    },
    {
      "emoji": "🌇",
      "name_en": "sunset",
      "name_ko": "석양"
    },
    {
      "emoji": "❤",
      "name_en": "Heart",
      "name_ko": "하트"
    },
    {
      "emoji": "🍵",
      "name_en": "Tea",
      "name_ko": "차"
    },
    {
      "emoji": "😍",
      "name_en": "Loving",
      "name_ko": "러블리"
    },
    {
      "emoji": "😤",
      "name_en": "Sulky, Sulk, Stubborn",
      "name_ko": "흥!"
    },
    {
      "emoji": "💐",
      "name_en": "bouquet",
      "name_ko": "부케"
    },
    {
      "emoji": "🦐",
      "name_en": "shrimp",
      "name_ko": "새우"
    },
    {
      "emoji": "🍷",
      "name_en": "wine glass",
      "name_ko": "와인잔"
    },
    {
      "emoji": "🖐",
      "name_en": "Byebye",
      "name_ko": "잘가"
    },
    {
      "emoji": "💑",
      "name_en": "couple, relationship",
      "name_ko": "연인"
    },
    {
      "emoji": "🎧",
      "name_en": "headphone",
      "name_ko": "헤드폰"
    },
    {
      "emoji": "🥵",
      "name_en": "Hot",
      "name_ko": "더워"
    },
    {
      "emoji": "🥕",
      "name_en": "carrot",
      "name_ko": "당근"
    },
    {
      "emoji": "🏂",
      "name_en": "Snowboarder",
      "name_ko": "스노우보더"
    },
    {
      "emoji": "👶",
      "name_en": "baby",
      "name_ko": "아기"
    },
    {
      "emoji": "🥖",
      "name_en": "Baguette bread",
      "name_ko": "빵"
    },
    {
      "emoji": "🌕",
      "name_en": "Moon",
      "name_ko": "달"
    },
    {
      "emoji": "💄",
      "name_en": "lipstick",
      "name_ko": "립스틱"
    },
    {
      "emoji": "🍣",
      "name_en": "sushi",
      "name_ko": "초밥"
    },
    {
      "emoji": "💸",
      "name_en": "Poor",
      "name_ko": "가난"
    },
    {
      "emoji": "👌",
      "name_en": "OK",
      "name_ko": "ㅇㅋ"
    },
    {
      "emoji": "🎹",
      "name_en": "musical keyboard",
      "name_ko": "키보드 건반"
    },
    {
      "emoji": "🎸",
      "name_en": "guitar",
      "name_ko": "기타"
    },
    {
      "emoji": "😪",
      "name_en": "Sleepy",
      "name_ko": "졸려"
    },
    {
      "emoji": "🆘",
      "name_en": "SOS, Help",
      "name_ko": "SOS"
    },
    {
      "emoji": "❌",
      "name_en": "No",
      "name_ko": "아니"
    },
    {
      "emoji": "🧀",
      "name_en": "cheese",
      "name_ko": "치즈"
    },
    {
      "emoji": "🐧",
      "name_en": "penguin",
      "name_ko": "펭귄"
    },
    {
      "emoji": "☂",
      "name_en": "Umbrella",
      "name_ko": "우산"
    },
    {
      "emoji": "😴",
      "name_en": "Sleep, Go to Bed",
      "name_ko": "잠"
    },
    {
      "emoji": "🌃",
      "name_en": "night",
      "name_ko": "밤"
    },
    {
      "emoji": "🛍",
      "name_en": "shopping bags",
      "name_ko": "쇼핑백"
    },
    {
      "emoji": "🤤",
      "name_en": "Hungry",
      "name_ko": "배고파"
    },
    {
      "emoji": "🙌",
      "name_en": "Cheering",
      "name_ko": "응원"
    },
    {
      "emoji": "☀",
      "name_en": "Sun",
      "name_ko": "해, 태양"
    },
    {
      "emoji": "🤒",
      "name_en": "Sick",
      "name_ko": "아파"
    },
    {
      "emoji": "🗯",
      "name_en": "argue",
      "name_ko": "다투다"
    },
    {
      "emoji": "🎂",
      "name_en": "Birthday",
      "name_ko": "생일"
    },
    {
      "emoji": "🏌",
      "name_en": "golf, golfing, play golf, golfer",
      "name_ko": "골프"
    },
    {
      "emoji": "🍩",
      "name_en": "Doughnut",
      "name_ko": "도넛"
    },
    {
      "emoji": "🛀",
      "name_en": "Bath",
      "name_ko": "욕조"
    },
    {
      "emoji": "🌈",
      "name_en": "rainbow",
      "name_ko": "무지개"
    },
    {
      "emoji": "🔋",
      "name_en": "battery",
      "name_ko": "배터리, 건전지"
    },
    {
      "emoji": "🍍",
      "name_en": "Pineapple",
      "name_ko": "파인애플"
    },
    {
      "emoji": "🎁",
      "name_en": "Gift, Present",
      "name_ko": "선물"
    },
    {
      "emoji": "🥭",
      "name_en": "Mango",
      "name_ko": "망고"
    },
    {
      "emoji": "🐵",
      "name_en": "monkey",
      "name_ko": "원숭이"
    },
    {
      "emoji": "👍",
      "name_en": "Good",
      "name_ko": "굿"
    },
    {
      "emoji": "🕊",
      "name_en": "dove",
      "name_ko": "비둘기"
    },
    {
      "emoji": "🌨",
      "name_en": "cloud with snow",
      "name_ko": "눈구름"
    },
    {
      "emoji": "🤣",
      "name_en": "LOL",
      "name_ko": "ㅋㅋㅋ"
    },
    {
      "emoji": "🌹",
      "name_en": "rose",
      "name_ko": "장미"
    },
    {
      "emoji": "🍓",
      "name_en": "strawberry",
      "name_ko": "딸기"
    },
    {
      "emoji": "🤬",
      "name_en": "Swear, Curse",
      "name_ko": "욕"
    },
    {
      "emoji": "🧸",
      "name_en": "toy",
      "name_ko": "장난감"
    },
    {
      "emoji": "📱",
      "name_en": "mobile phone",
      "name_ko": "핸드폰"
    },
    {
      "emoji": "⏰",
      "name_en": "alarm",
      "name_ko": "알람"
    },
    {
      "emoji": "📷",
      "name_en": "camera",
      "name_ko": "카메라"
    },
    {
      "emoji": "😜",
      "name_en": "Joking",
      "name_ko": "농담"
    },
    {
      "emoji": "🌺",
      "name_en": "flower, flowers",
      "name_ko": "꽃"
    },
    {
      "emoji": "🐭",
      "name_en": "Mouse, Rat",
      "name_ko": "쥐"
    },
    {
      "emoji": "♨",
      "name_en": "hot springs",
      "name_ko": "온천"
    },
    {
      "emoji": "📢",
      "name_en": "announce, announcement",
      "name_ko": "안내"
    },
    {
      "emoji": "🧎",
      "name_en": "Please",
      "name_ko": "제발"
    },
    {
      "emoji": "😉",
      "name_en": "Act charming",
      "name_ko": "멋져"
    },
    {
      "emoji": "🤼",
      "name_en": "Fight / Battle",
      "name_ko": "싸움"
    },
    {
      "emoji": "🍹",
      "name_en": "Juice",
      "name_ko": "쥬스"
    },
    {
      "emoji": "🍰",
      "name_en": "Cake",
      "name_ko": "케이크"
    },
    {
      "emoji": "🎵",
      "name_en": "Music, Musical Notes",
      "name_ko": "음악"
    },
    {
      "emoji": "🍸",
      "name_en": "Cocktail",
      "name_ko": "칵테일"
    },
    {
      "emoji": "📸",
      "name_en": "Take a Photo",
      "name_ko": "사진찍다"
    },
    {
      "emoji": "🍻",
      "name_en": "Cheers, Toast",
      "name_ko": "건배"
    },
    {
      "emoji": "🥶",
      "name_en": "Cold",
      "name_ko": "추워"
    },
    {
      "emoji": "🌼",
      "name_en": "Blossom",
      "name_ko": "만개"
    },
    {
      "emoji": "🍺",
      "name_en": "Drinking",
      "name_ko": "마셔"
    },
    {
      "emoji": "📦",
      "name_en": "package",
      "name_ko": "박스, 포장"
    },
    {
      "emoji": "🤨",
      "name_en": "Ambiguous",
      "name_ko": "모호한"
    },
    {
      "emoji": "☕",
      "name_en": "Coffee",
      "name_ko": "커피"
    },
    {
      "emoji": "🕴",
      "name_en": "Lonely, Alone",
      "name_ko": "혼자, 외로워"
    },
    {
      "emoji": "👹",
      "name_en": "Monster",
      "name_ko": "괴물"
    },
    {
      "emoji": "🍌",
      "name_en": "banana",
      "name_ko": "바나나"
    },
    {
      "emoji": "🌯",
      "name_en": "Burrito",
      "name_ko": "부리또"
    },
    {
      "emoji": "🎄",
      "name_en": "Christmas tree",
      "name_ko": "크리스마스 트리"
    },
    {
      "emoji": "🦟",
      "name_en": "mosquito",
      "name_ko": "모기"
    },
    {
      "emoji": "🍯",
      "name_en": "honey pot",
      "name_ko": "꿀단지"
    },
    {
      "emoji": "👏",
      "name_en": "Clap",
      "name_ko": "박수"
    },
    {
      "emoji": "⚽",
      "name_en": "soccer ball",
      "name_ko": "축구"
    },
    {
      "emoji": "🍪",
      "name_en": "Cookie",
      "name_ko": "쿠키"
    },
    {
      "emoji": "❓",
      "name_en": "Curious",
      "name_ko": "궁금"
    },
    {
      "emoji": "😵",
      "name_en": "Dizzy",
      "name_ko": "어지러워"
    },
    {
      "emoji": "🤏",
      "name_en": "Little Bit, Tiny",
      "name_ko": "약간"
    },
    {
      "emoji": "🍝",
      "name_en": "Spaghetti",
      "name_ko": "스파게티"
    },
    {
      "emoji": "🍳",
      "name_en": "cooking",
      "name_ko": "요리"
    },
    {
      "emoji": "🏆",
      "name_en": "Win, Trophy",
      "name_ko": "승리, 트로피"
    },
    {
      "emoji": "🍀",
      "name_en": "good luck",
      "name_ko": "행운"
    },
    {
      "emoji": "🎈",
      "name_en": "balloon",
      "name_ko": "풍선"
    },
    {
      "emoji": "✌",
      "name_en": "V Sign",
      "name_ko": "브이"
    },
    {
      "emoji": "😩",
      "name_en": "Tired",
      "name_ko": "피곤해"
    },
    {
      "emoji": "🏬",
      "name_en": "department store",
      "name_ko": "백화점"
    },
    {
      "emoji": "📖",
      "name_en": "Study, Homework",
      "name_ko": "공부, 숙제"
    },
    {
      "emoji": "😑",
      "name_en": "Bored / Boring",
      "name_ko": "지루해"
    },
    {
      "emoji": "🍫",
      "name_en": "chocolate bar",
      "name_ko": "초콜릿"
    },
    {
      "emoji": "🥄",
      "name_en": "spoon",
      "name_ko": "스푼"
    },
    {
      "emoji": "🤳",
      "name_en": "Selfie",
      "name_ko": "셀카"
    },
    {
      "emoji": "🎮",
      "name_en": "Game, Play Game",
      "name_ko": "게임"
    },
    {
      "emoji": "🕛",
      "name_en": "clock, time",
      "name_ko": "시계, 시간"
    },
    {
      "emoji": "🙃",
      "name_en": "Sarcastic",
      "name_ko": "냉소"
    },
    {
      "emoji": "😶",
      "name_en": "Quiet, Silent, Speechless",
      "name_ko": "쉿, 조용"
    },
    {
      "emoji": "⛰",
      "name_en": "mountain",
      "name_ko": "산"
    },
    {
      "emoji": "🛹",
      "name_en": "skateboard",
      "name_ko": "스케이트보드"
    },
    {
      "emoji": "😀",
      "name_en": "Grin, Smile",
      "name_ko": "미소"
    },
    {
      "emoji": "🧽",
      "name_en": "sponge",
      "name_ko": "스폰지"
    },
    {
      "emoji": "🛒",
      "name_en": "shopping cart",
      "name_ko": "쇼핑 카트"
    },
    {
      "emoji": "🥪",
      "name_en": "Sandwich",
      "name_ko": "샌드위치"
    },
    {
      "emoji": "🔫",
      "name_en": "pistol",
      "name_ko": "권총"
    },
    {
      "emoji": "🤗",
      "name_en": "Hug, Pat",
      "name_ko": "포옹"
    },
    {
      "emoji": "🥳",
      "name_en": "Party",
      "name_ko": "파티"
    },
    {
      "emoji": "😋",
      "name_en": "Full, Replete",
      "name_ko": "배불러"
    },
    {
      "emoji": "🏥",
      "name_en": "hospital",
      "name_ko": "병원"
    },
    {
      "emoji": "🤑",
      "name_en": "Rich",
      "name_ko": "부자"
    },
    {
      "emoji": "🤥",
      "name_en": "Lie",
      "name_ko": "거짓말"
    },
    {
      "emoji": "🦸",
      "name_en": "superhero, hero",
      "name_ko": "슈퍼 히어로, 영웅"
    },
    {
      "emoji": "🥺",
      "name_en": "Want, Eager, Hope",
      "name_ko": "희망"
    },
    {
      "emoji": "💊",
      "name_en": "pill",
      "name_ko": "약"
    },
    {
      "emoji": "😰",
      "name_en": "Nervous, Worried",
      "name_ko": "걱정, 긴장"
    },
    {
      "emoji": "🎣",
      "name_en": "fishing, go fishing",
      "name_ko": "낚시"
    },
    {
      "emoji": "🚶",
      "name_en": "Walk, Go, Leave",
      "name_ko": "걷다, 가다"
    },
    {
      "emoji": "🚽",
      "name_en": "restroom, toilet, bathroom",
      "name_ko": "화장실, 변기"
    },
    {
      "emoji": "🚪",
      "name_en": "door",
      "name_ko": "문"
    },
    {
      "emoji": "🤪",
      "name_en": "Crazy",
      "name_ko": "미쳤어"
    },
    {
      "emoji": "🤯",
      "name_en": "Busy",
      "name_ko": "바빠"
    },
    {
      "emoji": "💬",
      "name_en": "Talk, tell",
      "name_ko": "말하다, 대화"
    },
    {
      "emoji": "🤦",
      "name_en": "Frustrated, Frustration",
      "name_ko": "좌절"
    },
    {
      "emoji": "🤫",
      "name_en": "Shh",
      "name_ko": "쉿"
    },
    {
      "emoji": "🌩",
      "name_en": "lightning, thunder",
      "name_ko": "번개, 천둥"
    },
    {
      "emoji": "😏",
      "name_en": "Sly",
      "name_ko": "교활"
    },
    {
      "emoji": "📞",
      "name_en": "Contact, Call",
      "name_ko": "통화, 연락"
    },
    {
      "emoji": "🧐",
      "name_en": "Investigate, Look Closely",
      "name_ko": "조사, 자세히 보다"
    },
    {
      "emoji": "🧖",
      "name_en": "Bath",
      "name_ko": "목욕"
    },
    {
      "emoji": "🥔",
      "name_en": "potato",
      "name_ko": "감자"
    },
    {
      "emoji": "🤓",
      "name_en": "Study, Smart",
      "name_ko": "공부, 똑똑하다"
    },
    {
      "emoji": "🙈",
      "name_en": "Deny, Ignore",
      "name_ko": "무시"
    },
    {
      "emoji": "🦁",
      "name_en": "lion",
      "name_ko": "사자"
    },
    {
      "emoji": "🌧",
      "name_en": "Rain, Rainy",
      "name_ko": "비"
    },
    {
      "emoji": "🏍",
      "name_en": "Motorcycle",
      "name_ko": "오토바이"
    },
    {
      "emoji": "👊",
      "name_en": "Punch, Attack, Hit",
      "name_ko": "펀치, 공격, 때리다"
    },
    {
      "emoji": "😇",
      "name_en": "Angel, Innocent, Bless",
      "name_ko": "천사"
    },
    {
      "emoji": "🤷",
      "name_en": "Shrugging",
      "name_ko": "으쓱"
    },
    {
      "emoji": "🛑",
      "name_en": "stop sign, stop",
      "name_ko": "멈춰"
    },
    {
      "emoji": "😈",
      "name_en": "Devil, Demon, Evil",
      "name_ko": "악마"
    },
    {
      "emoji": "🏕",
      "name_en": "camping, tent",
      "name_ko": "캠프"
    },
    {
      "emoji": "🌸",
      "name_en": "cherry blossom",
      "name_ko": "벚꽃"
    },
    {
      "emoji": "🥁",
      "name_en": "drum",
      "name_ko": "드럼, 북"
    },
    {
      "emoji": "💃",
      "name_en": "Dancing, Dancer, Dance",
      "name_ko": "춤"
    },
    {
      "emoji": "🏃",
      "name_en": "Run, Running",
      "name_ko": "달리기"
    },
    {
      "emoji": "💵",
      "name_en": "Money, Cash",
      "name_ko": "돈"
    },
    {
      "emoji": "🍉",
      "name_en": "watermelon",
      "name_ko": "수박"
    },
    {
      "emoji": "🐟",
      "name_en": "Fish",
      "name_ko": "생선, 물고기"
    },
    {
      "emoji": "🎃",
      "name_en": "jack-o-lantern",
      "name_ko": "잭오랜턴"
    },
    {
      "emoji": "🍃",
      "name_en": "Leaves, Leaf",
      "name_ko": "잎사귀, 나뭇잎"
    },
    {
      "emoji": "🧻",
      "name_en": "roll of paper",
      "name_ko": "휴지"
    },
    {
      "emoji": "📕",
      "name_en": "literature, book, books, read, reading",
      "name_ko": "책, 문학, 읽다"
    },
    {
      "emoji": "🍽",
      "name_en": "Eat, Delicious",
      "name_ko": "먹다, 맛있어"
    },
    {
      "emoji": "🏋",
      "name_en": "Exercise",
      "name_ko": "운동"
    },
    {
      "emoji": "👨‍💻",
      "name_en": "Techonologist",
      "name_ko": "기술자"
    },
    {
      "emoji": "👭",
      "name_en": "hang out / friends",
      "name_ko": "놀다 / 친구"
    },
    {
      "emoji": "🧟",
      "name_en": "zombie, living dead, monster",
      "name_ko": "좀비"
    },
    {
      "emoji": "🔥",
      "name_en": "Fire",
      "name_ko": "불"
    },
    {
      "emoji": "🤝",
      "name_en": "Handshake, Hold hands",
      "name_ko": "악수"
    },
    {
      "emoji": "👨‍⚕️",
      "name_en": "doctor, nurse",
      "name_ko": "의사, 간호사"
    },
    {
      "emoji": "🤔",
      "name_en": "Think (thoughtful)",
      "name_ko": "생각"
    },
    {
      "emoji": "🙋",
      "name_en": "Me, Raise Hand",
      "name_ko": "저요 저요"
    },
    {
      "emoji": "👨‍🍳",
      "name_en": "cook, chef",
      "name_ko": "요리사, 셰프"
    },
    {
      "emoji": "👨‍🏭",
      "name_en": "factory worker, blue-collar",
      "name_ko": "공장 직원"
    },
    {
      "emoji": "🏖",
      "name_en": "beach",
      "name_ko": "해변"
    },
    {
      "emoji": "👨‍🔧",
      "name_en": "mechanic, mechanical",
      "name_ko": "수리공"
    },
    {
      "emoji": "✨",
      "name_en": "Sparkle",
      "name_ko": "반짝반짝"
    },
    {
      "emoji": "🤕",
      "name_en": "Hurt, Injured",
      "name_ko": "다치다"
    },
    {
      "emoji": "⚠",
      "name_en": "warn, warning",
      "name_ko": "경고"
    },
    {
      "emoji": "🏀",
      "name_en": "basketball",
      "name_ko": "농구"
    },
    {
      "emoji": "🚿",
      "name_en": "Shower",
      "name_ko": "샤워"
    },
    {
      "emoji": "🥤",
      "name_en": "Beverage",
      "name_ko": "음료수"
    },
    {
      "emoji": "🤮",
      "name_en": "Throw Up, Vomit",
      "name_ko": "우웩"
    },
    {
      "emoji": "👀",
      "name_en": "See, Look, Stare",
      "name_ko": "보다"
    },
    {
      "emoji": "☠",
      "name_en": "Death, Skull",
      "name_ko": "죽음, 해골"
    },
    {
      "emoji": "🤖",
      "name_en": "robot, cyber",
      "name_ko": "로봇"
    },
    {
      "emoji": "🥴",
      "name_en": "Woozy, Drunk",
      "name_ko": "취하다"
    },
    {
      "emoji": "😎",
      "name_en": "Cool",
      "name_ko": "멋져"
    },
    {
      "emoji": "💻",
      "name_en": "Computer",
      "name_ko": "컴퓨터"
    },
    {
      "emoji": "😷",
      "name_en": "Mask, Wearing Mask",
      "name_ko": "마스크"
    },
    {
      "emoji": "🙄",
      "name_en": "Duh, Whatever",
      "name_ko": "뭐래"
    },
    {
      "emoji": "🎅",
      "name_en": "Santa Claus, santa",
      "name_ko": "산타"
    },
    {
      "emoji": "☃",
      "name_en": "snowman",
      "name_ko": "눈사람"
    },
    {
      "emoji": "🍲",
      "name_en": "noodles",
      "name_ko": "국수"
    },
    {
      "emoji": "🤚",
      "name_en": "salute",
      "name_ko": "경례"
    },
    {
      "emoji": "🏴‍☠️",
      "name_en": "pirate flag",
      "name_ko": "해적"
    },
    {
      "emoji": "🤙",
      "name_en": "Promise",
      "name_ko": "약속"
    },
    {
      "emoji": "💇",
      "name_en": "haircut, get haircut",
      "name_ko": "헤어컷"
    },
    {
      "emoji": "🍨",
      "name_en": "ice cream",
      "name_ko": "아이스크림"
    },
    {
      "emoji": "💼",
      "name_en": "Business",
      "name_ko": "비지니스"
    },
    {
      "emoji": "🧞",
      "name_en": "genie, wish",
      "name_ko": "소원"
    },
    {
      "emoji": "🍚",
      "name_en": "rice",
      "name_ko": "밥, 쌀"
    },
    {
      "emoji": "🧘",
      "name_en": "Yoga",
      "name_ko": "요가"
    },
    {
      "emoji": "🏳",
      "name_en": "surrender, give up",
      "name_ko": "항복"
    },
    {
      "emoji": "🍁",
      "name_en": "Fall, Autumn",
      "name_ko": "가을"
    },
    {
      "emoji": "🌅",
      "name_en": "sunrise, morning, good morning",
      "name_ko": "일출, 아침"
    },
    {
      "emoji": "🚌",
      "name_en": "bus, public transportation",
      "name_ko": "버스"
    },
    {
      "emoji": "⭐",
      "name_en": "Star",
      "name_ko": "별"
    },
    {
      "emoji": "🧳",
      "name_en": "Suitcase, Traveling Bag",
      "name_ko": "캐리어, 여행가방"
    },
    {
      "emoji": "🚗",
      "name_en": "car, automobile, vehicle",
      "name_ko": "자동차"
    },
    {
      "emoji": "🚇",
      "name_en": "subway, public transportation",
      "name_ko": "지하철"
    }
  ]